<section class="ticket-section ">
    <div class="container">
        <div class="row">
            <div class="col-md-12 mb-3 text-center">
                <h2>Your Ticket</h2>
            </div>
            <div class="col-md-12">
                <img src="../../../../assets/img/pass/ticket.png" alt="" style="width: 100%;">
            </div>
        </div>
    </div>
</section>
<section class="ticket-section ticket-section-2 d-none">
    <div class="container">
        <div class="row">
            <div class="col-md-12 mb-3 text-center">
                <h2>Your Ticket</h2>
            </div>
            <div class="col-md-12">
                

                <swiper class="swiper-container clients-slider zoom-effect-container" fxFlex="auto"
                    [config]="Top_config">
                    <div class="swiper-slide">
                        <div class="tickets">
                            <div class="card main-card-div">
                                <div class="card-left">
                                    <img src="../../../../assets/img/pass/pass1.png" alt="" style="width: 100%;">
                                    <!-- <header class="header">
                            <img src="https://logodownload.org/wp-content/uploads/2019/05/air-france-logo-1.png"/>
                            <h5>BUSINESS CLASS</h5>
                          </header>
                          <main>
                            <div class="barcode">
                              <img src="https://www.freepnglogos.com/uploads/barcode-png/barcode-laser-code-vector-graphic-pixabay-3.png" />
                            </div>
                            <section class="main-details">
                              <p><span class="heading"> Passenger</span><br/>Chu, Lim</p>
                              <div class="centered">
                                <p><span class="heading"> From</span><br />YVR </p> &#8594;
                                 <p><span class="heading"> To</span><br /> CDG</p>
                                <p><span class="heading"> Date</span><br /> 08AUG2022</p>
                              </div>       
                              <div class="flight-details">
                                 <p><span class="heading"> Flight</span><br/>AF0123</p> 
                                <p><span class="heading"> Boarding</span><br/>10:00</p>
                                <p><span class="heading"> Gate</span><br/>G04</p>
                                <p><span class="heading"> Seat</span><br/>23A</p>
                              </div>
                              <h5>Gate closes 20 mins before depature</h5>
                            </section>
                          </main> -->
                                </div>
                                <div class="card-right">
                                    <header class="header">
                                        <div class="image-div">

                                            <img src="../../../../assets/img/pass/team.png" />
                                            <!-- <img src="https://api.tplsport.com/uploads/teamPic/teamMemberPic/5e74c202-6209-4df9-a344-c93e1b9cc215.png"/> -->
                                        </div>
                                        <!-- <div>
                                VS
                            </div>
                            <div class="image-div">
                               
                                <img src="https://api.tplsport.com/uploads/teamPic/teamLogo/6154e884-6cc8-4eae-be4b-d14eed2fc95b.png"/>
                                <img src="https://api.tplsport.com/uploads/teamPic/teamMemberPic/bff957f6-5e7c-4b92-99ba-c80b51adb1e0.png"/>
                            </div> -->

                                    </header>
                                    <main class="main">
                                        <div class="centered">
                                            <p><span class="heading"> Match
                                                </span><br />
                                                <span class="team-name">
                                                    <span class="team1">
                                                        Bengal Wizards
                                                    </span><br>
                                                    <span class="Vs">VS</span><br>
                                                    <span class="team2">
                                                        Hyderabad Strikers

                                                    </span>
                                                </span>
                                            </p>
                                            <!-- <p><span class="heading"> Seat</span><br/>23A</p> -->
                                        </div>
                                        <div class="centered">
                                            <p><span class="heading"> Address
                                                </span><br />Mahalunge Balewadi stadium, Baner - National Games Park,
                                                Pune, Maharashtra 411045</p>
                                            <!-- <p><span class="heading"> Seat</span><br/>23A</p> -->
                                        </div>

                                        <div class="centered">
                                            <p><span class="heading"> Time</span><br />04:00 PM </p>
                                            <p><span class="heading"> Date</span><br /> 12 December 2023</p>
                                        </div>
                                    </main>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="swiper-slide">
                        <div class="tickets">
                            <div class="card main-card-div">
                                <div class="card-left">
                                    <img src="../../../../assets/img/pass/pass1.png" alt="" style="width: 100%;">
                                    <!-- <header class="header">
                            <img src="https://logodownload.org/wp-content/uploads/2019/05/air-france-logo-1.png"/>
                            <h5>BUSINESS CLASS</h5>
                          </header>
                          <main>
                            <div class="barcode">
                              <img src="https://www.freepnglogos.com/uploads/barcode-png/barcode-laser-code-vector-graphic-pixabay-3.png" />
                            </div>
                            <section class="main-details">
                              <p><span class="heading"> Passenger</span><br/>Chu, Lim</p>
                              <div class="centered">
                                <p><span class="heading"> From</span><br />YVR </p> &#8594;
                                 <p><span class="heading"> To</span><br /> CDG</p>
                                <p><span class="heading"> Date</span><br /> 08AUG2022</p>
                              </div>       
                              <div class="flight-details">
                                 <p><span class="heading"> Flight</span><br/>AF0123</p> 
                                <p><span class="heading"> Boarding</span><br/>10:00</p>
                                <p><span class="heading"> Gate</span><br/>G04</p>
                                <p><span class="heading"> Seat</span><br/>23A</p>
                              </div>
                              <h5>Gate closes 20 mins before depature</h5>
                            </section>
                          </main> -->
                                </div>
                                <div class="card-right">
                                    <header class="header">
                                        <div class="image-div">

                                            <img src="../../../../assets/img/pass/team2.png" />
                                            <!-- <img src="https://api.tplsport.com/uploads/teamPic/teamMemberPic/5e74c202-6209-4df9-a344-c93e1b9cc215.png"/> -->
                                        </div>
                                        <!-- <div>
                                VS
                            </div>
                            <div class="image-div">
                               
                                <img src="https://api.tplsport.com/uploads/teamPic/teamLogo/6154e884-6cc8-4eae-be4b-d14eed2fc95b.png"/>
                                <img src="https://api.tplsport.com/uploads/teamPic/teamMemberPic/bff957f6-5e7c-4b92-99ba-c80b51adb1e0.png"/>
                            </div> -->

                                    </header>
                                    <main class="main">
                                        <div class="centered">
                                            <p><span class="heading"> Match
                                                </span><br />
                                                <span class="team-name">
                                                    <span class="team1">
                                                        Punjab Tigers

                                                    </span><br>
                                                    <span class="Vs">VS</span><br>
                                                    <span class="team2">
                                                        Mumbai Leon Army


                                                    </span>
                                                </span>
                                            </p>
                                            <!-- <p><span class="heading"> Seat</span><br/>23A</p> -->
                                        </div>
                                        <div class="centered">
                                            <p><span class="heading"> Address
                                                </span><br />Mahalunge Balewadi stadium, Baner - National Games Park,
                                                Pune, Maharashtra 411045</p>
                                            <!-- <p><span class="heading"> Seat</span><br/>23A</p> -->
                                        </div>

                                        <div class="centered">
                                            <p><span class="heading"> Time</span><br />04:00 PM </p>
                                            <p><span class="heading"> Date</span><br /> 14 December 2023</p>
                                        </div>
                                    </main>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="swiper-slide">
                        <div class="tickets">
                            <div class="card main-card-div">
                                <div class="card-left">
                                    <img src="../../../../assets/img/pass/pass1.png" alt="" style="width: 100%;">
                                    <!-- <header class="header">
                            <img src="https://logodownload.org/wp-content/uploads/2019/05/air-france-logo-1.png"/>
                            <h5>BUSINESS CLASS</h5>
                          </header>
                          <main>
                            <div class="barcode">
                              <img src="https://www.freepnglogos.com/uploads/barcode-png/barcode-laser-code-vector-graphic-pixabay-3.png" />
                            </div>
                            <section class="main-details">
                              <p><span class="heading"> Passenger</span><br/>Chu, Lim</p>
                              <div class="centered">
                                <p><span class="heading"> From</span><br />YVR </p> &#8594;
                                 <p><span class="heading"> To</span><br /> CDG</p>
                                <p><span class="heading"> Date</span><br /> 08AUG2022</p>
                              </div>       
                              <div class="flight-details">
                                 <p><span class="heading"> Flight</span><br/>AF0123</p> 
                                <p><span class="heading"> Boarding</span><br/>10:00</p>
                                <p><span class="heading"> Gate</span><br/>G04</p>
                                <p><span class="heading"> Seat</span><br/>23A</p>
                              </div>
                              <h5>Gate closes 20 mins before depature</h5>
                            </section>
                          </main> -->
                                </div>
                                <div class="card-right">
                                    <header class="header">
                                        <div class="image-div">

                                            <img src="../../../../assets/img/pass/team3.png" />
                                            <!-- <img src="https://api.tplsport.com/uploads/teamPic/teamMemberPic/5e74c202-6209-4df9-a344-c93e1b9cc215.png"/> -->
                                        </div>
                                        <!-- <div>
                                VS
                            </div>
                            <div class="image-div">
                               
                                <img src="https://api.tplsport.com/uploads/teamPic/teamLogo/6154e884-6cc8-4eae-be4b-d14eed2fc95b.png"/>
                                <img src="https://api.tplsport.com/uploads/teamPic/teamMemberPic/bff957f6-5e7c-4b92-99ba-c80b51adb1e0.png"/>
                            </div> -->

                                    </header>
                                    <main class="main">
                                        <div class="centered">
                                            <p><span class="heading"> Match
                                                </span><br />
                                                <span class="team-name">
                                                    <span class="team1">
                                                        Punjab Tigers

                                                    </span><br>
                                                    <span class="Vs">VS</span><br>
                                                    <span class="team2">
                                                        Mumbai Leon Army


                                                    </span>
                                                </span>
                                            </p>
                                            <!-- <p><span class="heading"> Seat</span><br/>23A</p> -->
                                        </div>
                                        <div class="centered">
                                            <p><span class="heading"> Address
                                                </span><br />Mahalunge Balewadi stadium, Baner - National Games Park,
                                                Pune, Maharashtra 411045</p>
                                            <!-- <p><span class="heading"> Seat</span><br/>23A</p> -->
                                        </div>

                                        <div class="centered">
                                            <p><span class="heading"> Time</span><br />04:00 PM </p>
                                            <p><span class="heading"> Date</span><br /> 14 December 2023</p>
                                        </div>
                                    </main>
                                </div>
                            </div>
                        </div>

                    </div>

                </swiper>


            </div>
        </div>
    </div>
</section>